import React from 'react';
import { EyeIcon, SparklesIcon, TrendingUpIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { useMarketplace } from '../../contexts/MarketplaceContext';
import type { MusicEvent } from '../../types/marketplace';
interface FeatureSheetProps {
  event: MusicEvent | null;
  onClose: () => void;
}
export function FeatureSheet({
  event,
  onClose
}: FeatureSheetProps) {
  const {
    featureEvent
  } = useMarketplace();
  return <Sheet open={Boolean(event)} onClose={onClose} title="Feature this event" footer={<Button variant="accent" size="lg" fullWidth onClick={() => {
    if (!event) return;
    featureEvent(event.id);
    toast.success(`${event.name} is featured`, {
      description: 'It now sits at the top of performer feeds.'
    });
    onClose();
  }} data-id="element-485" data-mp="3d3wnk47zom41">
          Feature for ฿490
        </Button>} data-id="element-484" data-mp="2yeieyyc8m8pp">
      {event && <div data-id="element-486" data-mp="1ed763ft5aa3y">
          <img src={event.photos[0]} alt="" className="aspect-[16/9] w-full rounded-md object-cover" data-id="element-487" data-mp="1edgtqwqpw56h" />
          <p className="mt-4 text-lg font-bold" data-id="element-488" data-mp="1nbsj6vfukwxc">{event.name}</p>
          <p className="mt-1 text-[15px] leading-relaxed text-ink-2" data-id="element-489" data-mp="1na7rreotxu3p">A one-off boost that lasts until your line-up is full.</p>
          <ul className="mt-5 divide-y divide-line" data-id="element-490" data-mp="1s8j0tn7aw0kv">
            {[{
          icon: TrendingUpIcon,
          text: 'Top of every matching performer’s Discover deck'
        }, {
          icon: SparklesIcon,
          text: 'A “Featured” tag on cards, lists and map pins'
        }, {
          icon: EyeIcon,
          text: 'Featured events get around 3× more applicants'
        }].map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-center gap-3 py-3 text-[15px]" data-id="element-491" data-mp="2b37qz3qe86fz">
                <Icon className="h-5 w-5 shrink-0 text-brand-strong" data-id="element-492" data-mp="2g2awepaaceoh" />
                {text}
              </li>)}
          </ul>
        </div>}
    </Sheet>;
}